import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAPZgK0FMeA7GUi91vkFPfQaPjRtWe7Ip8",
  authDomain: "street-paws-5db62.firebaseapp.com",
  projectId: "street-paws-5db62",
  storageBucket: "street-paws-5db62.appspot.com",
  messagingSenderId: "700465781662",
  appId: "1:700465781662:web:25fd662111e8c9e750d48f",
  measurementId: "G-NDVZD6NGRW"
};


const app = initializeApp(firebaseConfig);